/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setSpecialReportData } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IFormResponse } from '../../../common/common.types'

export function* getSpecialReportData() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const response: IFormResponse = yield call([optionsService, optionsService.getSpecialReportData])
    const { entity } = response
    if (entity) {
      yield put(setSpecialReportData(entity))
    }
  } catch (e) {
    yield put(throwPcrException(`getSpecialReportData() error: ${e}`))
  }
}

export function* getSpecialReportDataSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSpecialReportData)
}
